<template>
  <div class='fhlfx-wrap'>
    <div class="tree-content box" v-show="tabShow">
      <tab-tree :data="viewTreeData" @tabTreeDefault="tabTreeDefault" @tabTreeClick="tabTreeClick"></tab-tree>
    </div>
    <div class="content" :style="{width:tabShow?'calc(100% - 260px)':'100%'}">
      <div class="search-box box">
        <p class="time-info">
          数据更新间隔:<span class="time-num">{{timeNum}}</span>秒
        </p>
        <p class="surplus-time">
          下次更新时间:<span class="time-num">{{surplusTime}}</span>秒
        </p>
      </div>
      <div class="grid-content">
        <btn-show @show="tabShow = !tabShow" content="左边树"></btn-show>
        <div class="main">
          <div class="container" v-for="(item,index) in containerData" :key="index">
            <p class="container-name">{{item.containerName}}</p>
            <div class="container-grid">
              <div class="container-item" v-for="(itemItem,itemIndex) in item.data" :key="itemItem.id">
                <p class="container-info">
                  <span class="order">{{fromatIndex(itemIndex)}}</span>
                  <span class="name">名称:{{itemItem.measureName}}</span>
                  <span class="time">时间:{{itemItem.lastTime}}</span>
                  <span class="score">总有功功率:{{itemItem.score}}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TabTree from "@/components/common/TabTree.vue";
import { findDataByParam } from "@/utils/index.js";
import BtnShow from "@/components/common/BtnShow.vue";
import { clearInterval } from 'timers';
export default {
  data () {
    return {
      viewTreeData: [],//树数据
      selectedMeasure: {//当前选中的树数据
        measureId: "",
        measureName: "",
      },
      tabShow: true,//左边的树是否显示
      timeNum: 30,//更新间隔
      surplusTime: 0,//下次更新所剩时间
      containerData: [],//列表数据
      time: null,//定时器
      time_: null//定时器
    }
  },
  components: {
    TabTree, BtnShow
  },
  mounted () {
    this.surplusTime = this.timeNum;
    this.getTreeData();//获取树数据
  },
  methods: {
    async getTreeData () {//获取树数据
      let res = await this.$api.frontEndPageCustomParam.getMyFrontEndPageCustomParam(this.$store.state.user.currentCompanyId, "/nyyh/fhydph", null);
      this.viewTreeData = findDataByParam("viewTree", true, res.data);//数据赋值
    },
    async getData () {//根据参数获取数据
      if (!this.selectedMeasure) {//不存在选中的树节点
        this.$message.error("请选择节点信息！");
        return;
      }
      this.time && clearTimeout(this.time);
      let res = await this.$api.puzzle.rankOfLoadElectricity(this.selectedMeasure.measureId);//6331846276678785582
      if (!res.success) {
        this.$message.error(res.msg);
        return;
      }
      this.containerData = Object.assign([], res.data);
      this.time = setTimeout(() => {
        this.getData();
      }, this.timeNum * 1000);
      this.interTime();
    },
    tabTreeDefault (e) {//首次加载树时执行，保留默认的树选择
      this.selectedMeasure = e;
      this.getData();//获取数据
    },
    tabTreeClick (e) {//树节点点击的时候触发
      this.selectedMeasure = e;
      this.getData();//获取数据
    },
    interTime () {//定时器
      this.time_ = setTimeout(() => {
        this.surplusTime = (this.surplusTime - 1) <= 9 ? '0' + (this.surplusTime - 1) : (this.surplusTime - 1);
        if (this.surplusTime <= 0) {
          this.surplusTime = this.timeNum;
        } else {
          this.interTime();
        }
      }, 1000);
    }
  },
  computed: {
    fromatIndex () {
      return (index) => {
        return (index + 1) <= 9 ? '0' + (index + 1) : (index + 1);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fhlfx-wrap {
  width: 100%;
  height: 100%;
  display: flex;
  overflow: hidden;
  padding: 23px;
  box-sizing: border-box;
  .tree-content {
    width: 260px;
    margin-right: 14px;
  }
  .content {
    position: relative;
    .search-box {
      height: 36px;
      line-height: 36px;
      text-align: left;
      padding-left: 10px;
      box-sizing: border-box;
      display: flex;
      .option {
        width: 150px;
        margin: 0 0 0 10px;
      }
      .time-num {
        font-weight: bold;
        font-size: 18px;
        color: #409eff;
        margin: 0 5px;
      }
      .surplus-time {
        margin-left: 20px;
      }
    }
    .grid-content {
      position: absolute;
      bottom: 0;
      width: 100%;
      top: 50px;
      border-radius: 4px;
      box-sizing: border-box;
      .main {
        width: 100%;
        height: 100%;
        .container {
          width: 100%;
          height: auto;
          background: #fff;
          border-radius: 4px;
          overflow: hidden;
          text-align: left;
          padding: 5px;
          box-sizing: border-box;
          .container-name {
            color: #409eff;
            font-size: 18px;
            font-weight: bold;
          }
          .container-grid {
            color: #000;
            display: inline-grid;
            grid-template-columns: repeat(2, 1fr);
            padding: 10px;
            box-sizing: border-box;
            width: 100%;
            .container-item {
              font-size: 16px;
              line-height: 28px;
              border: 1px solid #000;
              box-sizing: border-box;
              margin: 0 0 -1px -1px;
              .container-info {
                display: flex;
                .order {
                  width: 30px;
                  text-align: center;
                }
                .name {
                  flex: 1;
                }
                .time {
                  flex: 1;
                }
                .score {
                  flex: 1;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>